<span class="field-value">
  <span *ngIf="showFlag && countryFlag" class="country-flag">{{ countryFlag }}</span>
  <span class="field-view-value">{{ countryName }}</span>
</span>
